/* Only use this approach in situations where an .scss solution is not possible */

interface ThemedVariables {
	"$body-color": string,
	"$input-bg": string,
	"$link-color": string,
	"$vs-component-placeholder-color": string,
}

interface SharedVariables {
}

const darkVariables: ThemedVariables = {
	"$body-color": "#fff",
	"$input-bg": "#294145",
	"$link-color": "#DF520A",
	"$vs-component-placeholder-color": "rgba(238,238,238,0.6)"
}

const lightVariables: ThemedVariables = {
	"$body-color": "#000",
	"$input-bg": "#EDEFF0",
	"$link-color": "#DF520A",
	"$vs-component-placeholder-color": "#B6B6B6"
}

const globalConstants: SharedVariables = {
}

export const StylingConstants = {
	dark: darkVariables,
	light: lightVariables,
	global: globalConstants
}
